import { createFilterModel } from "@/components/meds/meds-search/controls/filter-model";

export function resolveInitialFilters(
  filters: MedsSearchFilters,
  searchParams: Record<string, string>,
) {
  const filterOptions = {
    price: filters[0].options,
    kinds: filters[1].options,
  };
  const initialFilters = createFilterModel(filterOptions, searchParams);

  initialFilters.forNurse.disabled = !filters[2].disabled;
  initialFilters.withoutPrescription.disabled = !filters[3].disabled;

  return initialFilters;
}
